import {TyrePositionDto} from "../models/step";

/** Request part of POST /v1/web-app/analyses/{analysisId}/(wear|reference)-cbd */
export class CreateCbdRequestDto {
  constructor(
    public position: TyrePositionDto,
    public originalWidth: number,
    public originalHeight: number
  ) {}
}

/** Response of POST /v1/web-app/analyses/{analysisId}/(wear|reference)-cbd */
export interface CreateCbdResponseDto {
  id: number;
  sseTyreAnalysisToken: string;
  mercureTopic: string;
}
